module.exports = __webpack_public_path__ + "static/media/sp-1500c.12a1e2f1.jpg";